import { Link, LinkProps } from "react-router-dom";
import { forwardRef } from "react";
import { prefetchRoute } from "@/lib/routePrefetch";

type Props = LinkProps & { to: string };

// Drop-in replacement for react-router Link that warms the route chunk
// on hover, focus or touch.
const PrefetchLink = forwardRef<HTMLAnchorElement, Props>(
  ({ to, onMouseEnter, onFocus, onTouchStart, ...rest }, ref) => {
    const warm = () => prefetchRoute(typeof to === "string" ? to : "");
    return (
      <Link
        ref={ref}
        to={to}
        onMouseEnter={(e) => { warm(); onMouseEnter?.(e); }}
        onFocus={(e) => { warm(); onFocus?.(e); }}
        onTouchStart={(e) => { warm(); onTouchStart?.(e); }}
        {...rest}
      />
    );
  }
);
PrefetchLink.displayName = "PrefetchLink";

export default PrefetchLink;
